import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import msalInstance from "./auth/msalInstance";

const root = ReactDOM.createRoot(document.getElementById("root"));

/**
 * Strips the OIDC logout artefacts Entra echoes back to postLogoutRedirectUri
 * (e.g. "/?state=eyJpZCI6..."). MSAL only reads/cleans the URL fragment by
 * default (OIDCOptions.responseMode is FRAGMENT), so a `state` in the query
 * string is ignored and left behind. Inert, but it looks broken and gets
 * bookmarked. Guarded on `code` being absent so it can never interfere with a
 * real auth response.
 */
const cleanupLogoutParams = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("state") || url.searchParams.has("code")) return;

  url.searchParams.delete("state");
  url.searchParams.delete("session_state");
  window.history.replaceState(
    null,
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
};

// Initialize MSAL and process any redirect response BEFORE React renders.
// This ensures the auth code in the URL hash is consumed before routing kicks in.

msalInstance
  .initialize()
  .then(() => {
    return msalInstance.handleRedirectPromise();
  })
  .then((response) => {
    if (response) {
      sessionStorage.setItem("loginType", "sso");
      // Set active account so MsalProvider picks it up immediately on mount
      msalInstance.setActiveAccount(response.account);
      // Navigate to /home BEFORE React renders so the router starts at /home
      window.history.replaceState(null, "", "/home");
    } else {
        // Plain load, refresh, or the return leg of a logout redirect —
        // only the last of those leaves query params behind.
        cleanupLogoutParams();
    }
    // Always ensure an active account exists (e.g. after a page refresh, when
    // handleRedirectPromise resolves to null but the MSAL cache still has one).
    if (!msalInstance.getActiveAccount()) {
      const [account] = msalInstance.getAllAccounts();
      if (account) {
        msalInstance.setActiveAccount(account);
      }
    }
    root.render(<App />);
  })
  .catch((err) => {
    console.error("[index] MSAL initialization/redirect failed:", err);
    root.render(<App />);
  });
